<template>
  <v-alert class="password-requirements" outlined type="info">
    <div class="font-weight-medium mb-2">
      {{ $t("passwordRequirementsTitle") }}
    </div>
    <div
      v-for="requirement in requirements"
      :key="requirement.key"
      class="d-flex align-center"
      :class="requirement.valid ? 'success--text' : 'grey--text text--darken-2'"
    >
      <v-icon
        small
        class="mr-2"
        :color="requirement.valid ? 'success' : 'grey darken-1'"
      >
        {{ requirement.valid ? "mdi-check-circle" : "mdi-circle-outline" }}
      </v-icon>
      {{ requirement.label }}
    </div>
  </v-alert>
</template>

<script>
import { getPasswordChecks } from "@/utils/passwordPolicy";

export default {
  name: "PasswordRequirements",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    requirements() {
      const checks = getPasswordChecks(this.value);
      return [
        {
          key: "minLength",
          label: this.$i18n.t("passwordRequirementMinLength"),
          valid: checks.minLength,
        },
        {
          key: "uppercase",
          label: this.$i18n.t("passwordRequirementUppercase"),
          valid: checks.uppercase,
        },
        {
          key: "lowercase",
          label: this.$i18n.t("passwordRequirementLowercase"),
          valid: checks.lowercase,
        },
        {
          key: "number",
          label: this.$i18n.t("passwordRequirementNumber"),
          valid: checks.number,
        },
        {
          key: "special",
          label: this.$i18n.t("passwordRequirementSpecial"),
          valid: checks.special,
        },
      ];
    },
  },
};
</script>
